import React from "react";

import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import useStyles from "@hooks/useStyles";

import { adjective as clientAdjective } from "@language/client";
import Logo from "@components/Global/Custom/Logo/Logo";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";

const { BRAND_NAME } = process.env;

const ProComparison = () => {
	const classes = useStyles("Pro");

	return (
		<Box
			component="section"
			className={classes.hiwWrapper}
			display={"flex"}
			alignItems={"center"}
			justifyContent={"center"}
		>
			<Container maxWidth={"md"}>
				<h2 className={classes.joinH2}>
					{`${BRAND_NAME} brings you the right customers`}
				</h2>

				<Grid
					container
					spacing={8}
					justifyContent="center"
					alignItems="center"
					className={classes.stepBox}
					style={{
						backgroundColor: "#FFF",
					}}
				>
					<Grid item xs={12}>
						<div className={classes.compareFlex}>
							<CheckIcon fontSize="large" style={{ color: "#2ac389" }} />
							<div>
								<h3 className={classes.compareH3}>No signup or listing fees</h3>
								<div className={classes.compareText}>
									Say goodbye to pesky signup or listing fees.
								</div>
							</div>
						</div>
					</Grid>
					<Grid item xs={12}>
						<div className={classes.compareFlex}>
							<CheckIcon fontSize="large" style={{ color: "#2ac389" }} />
							<div>
								<h3 className={classes.compareH3}>Valuable customers</h3>
								<div className={classes.compareText}>
									Connect with vetted customers who are close to making a hiring
									decision, maximizing your ROI.
								</div>
							</div>
						</div>
					</Grid>

					<Grid item xs={12}>
						<div className={classes.compareFlex}>
							<CheckIcon fontSize="large" style={{ color: "#2ac389" }} />
							<div>
								<h3 className={classes.compareH3}>Limited competition</h3>
								<div className={classes.compareText}>
									Thrive in a marketplace where competition is limited, allowing
									your business to shine and stand out.
								</div>
							</div>
						</div>
					</Grid>
					<Grid item xs={12}>
						<div className={classes.compareFlex}>
							<CheckIcon fontSize="large" style={{ color: "#2ac389" }} />
							<div>
								<h3 className={classes.compareH3}>
									Get customers' phone number
								</h3>
								<div className={classes.compareText}>
									Direct access to customers' phone numbers enables swift
									conversions from inquiries to profitable hires.
								</div>
							</div>
						</div>
					</Grid>
					<Grid item xs={12}>
						<div className={classes.compareFlex}>
							<CheckIcon fontSize="large" style={{ color: "#2ac389" }} />
							<div>
								<h3 className={classes.compareH3}>Automatically book jobs</h3>
								<div className={classes.compareText}>
									Get confirmed jobs in your inbox, saving you time and energy
									so you can focus on delivering exceptional services.
								</div>
							</div>
						</div>
					</Grid>
					<Grid item xs={12}>
						<div className={classes.compareFlex}>
							<CheckIcon fontSize="large" style={{ color: "#2ac389" }} />
							<div>
								<h3 className={classes.compareH3}>First-class support</h3>
								<div className={classes.compareText}>
									Experience first-class support: We're here to help 24/7 at
									every step.
								</div>
							</div>
						</div>
					</Grid>
				</Grid>
			</Container>
		</Box>
	);
};

export default ProComparison;
